module.exports = [
	{
		"name": "AMC 600 North Michigan 9",
		"address": [
			"600 N. Michigan Ave."
		],
		"city": "Chicago",
		"state": "IL",
		"zip": "60611",
		"lat": 41.8929482,
		"long": -87.6248932
	},
	{
		"name": "AMC River East 21",
		"address": [
			"322 E Illinois St"
		],
		"city": "Chicago",
		"state": "IL",
		"zip": "60611",
		"lat": 41.8914110822661,
		"long": -87.6191188849703
	},
	{
		"name": "ShowPlace ICON",
		"address": [
			"1011 South Delano Ct E"
		],
		"city": "Chicago",
		"state": "IL",
		"zip": "60605",
		"lat": 41.8695699,
		"long": -87.6327087
	},
	{
		"name": "Landmark Century Centre Cinema",
		"address": [
			"2828 N Clark St"
		],
		"city": "Chicago",
		"state": "IL",
		"zip": "60657",
		"lat": 41.9333458995629,
		"long": -87.6456908621007
	},
	{
		"name": "Regal Cinemas Webster Place 11",
		"address": [
			"1471 W. Webster Avenue"
		],
		"city": "Chicago",
		"state": "IL",
		"zip": "60614",
		"lat": 41.9210299,
		"long": -87.6650363
	},
	{
		"name": "The New 400 Theaters",
		"address": [
			"6746 N Sheridan Rd"
		],
		"city": "Chicago",
		"state": "IL",
		"zip": "60626",
		"lat": 42.0047915469455,
		"long": -87.661452849749
	},
	{
		"name": "AMC Dine-in Theatres Block 37",
		"address": [
			"108 N State Street",
			"Ste 434"
		],
		"city": "Chicago",
		"state": "IL",
		"zip": "60602",
		"lat": 41.8841154693164,
		"long": -87.6291025506555
	},
	{
		"name": "Regal Cinemas City North 14 IMAX & RPX",
		"address": [
			"2600 North Western Avenue"
		],
		"city": "Chicago",
		"state": "IL",
		"zip": "60647",
		"lat": 41.929253,
		"long": -87.688306
	},
	{
		"name": "Logan Theatre",
		"address": [
			"2646 N Milwaukee Ave"
		],
		"city": "Chicago",
		"state": "IL",
		"zip": "60647",
		"lat": 41.9297718,
		"long": -87.7088448
	},
	{
		"name": "Music Box Theatre",
		"address": [
			"3733 N Southport Ave"
		],
		"city": "Chicago",
		"state": "IL",
		"zip": "60613",
		"lat": 41.9498769279567,
		"long": -87.6639136233639
	},
	{
		"name": "AMC Showplace Galewood 14",
		"address": [
			"5530 W. Homer Blvd"
		],
		"city": "Chicago",
		"state": "IL",
		"zip": "60639",
		"lat": 41.9157524108887,
		"long": -87.7646865844727
	},
	{
		"name": "ArcLight Cinemas Chicago",
		"address": [
			"1500 N Clybourn Ave",
			"Ste C301"
		],
		"city": "Chicago",
		"state": "IL",
		"zip": "60610",
		"lat": 41.908390045166,
		"long": -87.6468353271484
	},
	{
		"name": "The Gene Siskel Film Center",
		"address": [
			"164 N. State Street"
		],
		"city": "Chicago",
		"state": "IL",
		"zip": "60601",
		"lat": 41.88486,
		"long": -87.62831
	},
	{
		"name": "Cadillac Palace Theatre",
		"address": [
			"151 W Randolph St"
		],
		"city": "Chicago",
		"state": "IL",
		"zip": "60602",
		"lat": 41.8843208661099,
		"long": -87.633022255485
	},
	{
		"name": "Harper Theater",
		"address": [
			"5238 S Harper Ave"
		],
		"city": "Chicago",
		"state": "IL",
		"zip": "60615",
		"lat": 41.8001654,
		"long": -87.589112
	},
	{
		"name": "The Davis Theater",
		"address": [
			"4614 N Lincoln Ave"
		],
		"city": "Chicago",
		"state": "IL",
		"zip": "60625",
		"lat": 41.965457342498,
		"long": -87.686614530791
	},
	{
		"name": "AMC Ford City 14",
		"address": [
			"7601 S. Cicero Ave."
		],
		"city": "Chicago",
		"state": "IL",
		"zip": "60652",
		"lat": 41.7543346532474,
		"long": -87.7334100196645
	},
	{
		"name": "Doc Films",
		"address": [
			"1212 E 59th St"
		],
		"city": "Chicago",
		"state": "IL",
		"zip": "60637",
		"lat": 41.7881609819701,
		"long": -87.5955498218536
	},
	{
		"name": "Navy Pier IMAX Theatre",
		"address": [
			"700 E Grand Ave"
		],
		"city": "Chicago",
		"state": "IL",
		"zip": "60611",
		"lat": 41.8919367794301,
		"long": -87.6092361832552
	},
	{
		"name": "Patio Theatre",
		"address": [
			"6008 W Irving Park Rd"
		],
		"city": "Chicago",
		"state": "IL",
		"zip": "60634",
		"lat": 41.9531909170223,
		"long": -87.7770041410385
	},
	{
		"name": "Brew & View At The Vic",
		"address": [
			"3145 N Sheffield Ave"
		],
		"city": "Chicago",
		"state": "IL",
		"zip": "60657",
		"lat": 41.9395764277146,
		"long": -87.6538688773887
	},
	{
		"name": "Apollo Theater",
		"address": [
			"2540 N Lincoln"
		],
		"city": "Chicago",
		"state": "IL",
		"zip": "60614",
		"lat": 41.92799,
		"long": -87.65275
	},
	{
		"name": "Biograph Theatre",
		"address": [
			"2433 N Lincoln Ave"
		],
		"city": "Chicago",
		"state": "IL",
		"zip": "60614",
		"lat": 41.926361943392,
		"long": -87.6498091885205
	},
	{
		"name": "The Vic Theatre",
		"address": [
			"3145 N Sheffield Ave"
		],
		"city": "Chicago",
		"state": "IL",
		"zip": "60657",
		"lat": 41.93953,
		"long": -87.6538
	},
	{
		"name": "Facets",
		"address": [
			"1517 W Fullerton Ave"
		],
		"city": "Chicago",
		"state": "IL",
		"zip": "60614",
		"lat": 41.925084,
		"long": -87.6665772
	},
	{
		"name": "Beverly Arts Center",
		"address": [
			"2407 W 111th St"
		],
		"city": "Chicago",
		"state": "IL",
		"zip": "60655",
		"lat": 41.6916451,
		"long": -87.68136
	},
	{
		"name": "The Lake Street Screening Room",
		"address": [
			"70 East Lake Street"
		],
		"city": "Chicago",
		"state": "IL",
		"zip": "60601",
		"lat": 41.8860699,
		"long": -87.62555
	},
	{
		"name": "Century 12 Evanston / CineArts 6 and XD",
		"address": [
			"1715 Maple Ave"
		],
		"city": "Evanston",
		"state": "IL",
		"zip": "60201",
		"lat": 42.0490171855251,
		"long": -87.6844339790544
	},
	{
		"name": "Comfort Station Logan Square",
		"address": [
			"2579 N Milwaukee Ave"
		],
		"city": "Chicago",
		"state": "IL",
		"zip": "60647",
		"lat": 41.927789747715,
		"long": -87.7052240073681
	},
	{
		"name": "Aragon Ballroom",
		"address": [
			"1106 W Lawrence"
		],
		"city": "Chicago",
		"state": "IL",
		"zip": "60640",
		"lat": 41.9691849,
		"long": -87.657838
	},
	{
		"name": "Studio Movie Grill",
		"address": [
			"210 W 87th St"
		],
		"city": "Chicago",
		"state": "IL",
		"zip": "60620",
		"lat": 41.7362339,
		"long": -87.6292822
	},
	{
		"name": "Chicago Filmmakers",
		"address": [
			"5243 N Clark St"
		],
		"city": "Chicago",
		"state": "IL",
		"zip": "60640",
		"lat": 41.9773315,
		"long": -87.6681937
	},
	{
		"name": "Muvico Rosemont",
		"address": [
			"9701 Bryn Mawr Ave"
		],
		"city": "Rosemont",
		"state": "IL",
		"zip": "60018",
		"lat": 41.9802849,
		"long": -87.8678948
	},
	{
		"name": "Ice-Lawndale Theatres",
		"address": [
			"3330 W Roosevelt Rd"
		],
		"city": "Chicago",
		"state": "IL",
		"zip": "60624",
		"lat": 41.86668,
		"long": -87.70937
	},
	{
		"name": "Chicago Underground Film Fest",
		"address": [
			"Viaduct Theatre",
			"3111 N Western Ave"
		],
		"city": "Chicago",
		"state": "IL",
		"zip": "60618",
		"lat": 41.9381,
		"long": -87.68763
	},
	{
		"name": "Black Ensemble Theater Cultural Center",
		"address": [
			"4450 N. Clark St"
		],
		"city": "Chicago",
		"state": "IL",
		"zip": "60640",
		"lat": 41.9632,
		"long": -87.6666599
	},
	{
		"name": "Lake Theatre",
		"address": [
			"1022 Lake Street"
		],
		"city": "Oak Park",
		"state": "IL",
		"zip": "60301",
		"lat": 41.8887649,
		"long": -87.8017217
	},
	{
		"name": "Northwest Chicago Film Society",
		"address": [
			"6008 W Irving Park Rd"
		],
		"city": "Chicago",
		"state": "IL",
		"zip": "60634",
		"lat": 41.9530990719795,
		"long": -87.7770549058914
	},
	{
		"name": "AMC Showplace Village Crossing 18",
		"address": [
			"7000 Carpenter Rd"
		],
		"city": "Skokie",
		"state": "IL",
		"zip": "60077",
		"lat": 42.009325717995,
		"long": -87.764987610251
	},
	{
		"name": "Kerasotes Theatres",
		"address": [
			"224 N Desplaines St"
		],
		"city": "Chicago",
		"state": "IL",
		"zip": "60661",
		"lat": 41.8865,
		"long": -87.64456
	},
	{
		"name": "Logan Square International Film Series",
		"address": [
			"Comfort Station Logan Square",
			"2579 N Milwaukee Ave"
		],
		"city": "Chicago",
		"state": "IL",
		"zip": "60647",
		"lat": 41.927789747715,
		"long": -87.7052240073681
	},
	{
		"name": "119 Productions",
		"address": [
			"Irving Park Rd and Southport Ave"
		],
		"city": "Chicago",
		"state": "IL",
		"zip": "60613",
		"lat": 41.9543476,
		"long": -87.6642181
	},
	{
		"name": "Midnight Madness-Rocky Horror Picture Show",
		"address": [
			"3733 N Southport Ave"
		],
		"city": "Chicago",
		"state": "IL",
		"zip": "60686",
		"lat": 41.9499032,
		"long": -87.6638908
	},
	{
		"name": "AMC Chicago Ridge 6",
		"address": [
			"500 Chicago Ridge Mall"
		],
		"city": "Chicago Ridge",
		"state": "IL",
		"zip": "60415",
		"lat": 41.713602,
		"long": -87.7841434
	},
	{
		"name": "Signal Ensemble Theatre",
		"address": [
			"1812 W Berenice Ave"
		],
		"city": "Chicago",
		"state": "IL",
		"zip": "60613",
		"lat": 41.9515346735716,
		"long": -87.6748741418123
	},
	{
		"name": "Nolo Digital Film",
		"address": [
			"230 E Ohio",
			"Ste 200"
		],
		"city": "Chicago",
		"state": "IL",
		"zip": "60611",
		"lat": 41.892787,
		"long": -87.62162
	},
	{
		"name": "North Riverside Luxury 6",
		"address": [
			"7501 W Cermak Rd"
		],
		"city": "North Riverside",
		"state": "IL",
		"zip": "60546",
		"lat": 41.8488998,
		"long": -87.8110428
	},
	{
		"name": "AMC Showplace Cicero 14",
		"address": [
			"4779 W Cermak"
		],
		"city": "Cicero",
		"state": "IL",
		"zip": "60804",
		"lat": 41.8510851,
		"long": -87.7435012
	},
	{
		"name": "Summer Movies in the Parks hosted by the Chicago Park District",
		"address": [],
		"city": "Chicago",
		"state": "IL",
		"zip": "60686",
		"lat": 41.85,
		"long": -87.65
	},
	{
		"name": "La Grange Theatre",
		"address": [
			"80 S La Grange Rd"
		],
		"city": "La Grange",
		"state": "IL",
		"zip": "60525",
		"lat": 41.8126032,
		"long": -87.869719
	},
	{
		"name": "Newhart Family Theater",
		"address": [
			"1020 W Sheridan Rd"
		],
		"city": "Chicago",
		"state": "IL",
		"zip": "60626",
		"lat": 41.998394,
		"long": -87.6567841
	},
	{
		"name": "Cinemark",
		"address": [
			"1001 W North Ave"
		],
		"city": "Melrose Park",
		"state": "IL",
		"zip": "60160",
		"lat": 41.9093285267517,
		"long": -87.8461840319416
	},
	{
		"name": "Pickwick Theater",
		"address": [
			"5 S Prospect Ave"
		],
		"city": "Park Ridge",
		"state": "IL",
		"zip": "60068",
		"lat": 42.0105099,
		"long": -87.8292
	},
	{
		"name": "AMC Showplace Niles 12",
		"address": [
			"301 Golf Mill Center"
		],
		"city": "Niles",
		"state": "IL",
		"zip": "60714",
		"lat": 42.050354629755,
		"long": -87.8398682177067
	},
	{
		"name": "Marcus Cinemas Orland Park",
		"address": [
			"16350 S La Grange Rd"
		],
		"city": "Orland Park",
		"state": "IL",
		"zip": "60467",
		"lat": 41.59185,
		"long": -87.853736
	},
	{
		"name": "Chicago Latino Film Festival",
		"address": [
			"322 E Illinois St"
		],
		"city": "Chicago",
		"state": "IL",
		"zip": "60611",
		"lat": 41.891453,
		"long": -87.618942
	},
	{
		"name": "Portage Theater",
		"address": [
			"4050 N Milwaukee Ave"
		],
		"city": "Chicago",
		"state": "IL",
		"zip": "60641",
		"lat": 41.9542154,
		"long": -87.7489356
	},
	{
		"name": "AMC Loews Quarry Cinemas 14",
		"address": [
			"9201 63rd St."
		],
		"city": "Hodgkins",
		"state": "IL",
		"zip": "60525",
		"lat": 41.7759649,
		"long": -87.8586357
	},
	{
		"name": "Wilmette Theatre",
		"address": [
			"1122 Central Ave"
		],
		"city": "Wilmette",
		"state": "IL",
		"zip": "60091",
		"lat": 42.0768215594745,
		"long": -87.7059808045755
	},
	{
		"name": "Chicago Irish Film Festival",
		"address": [
			"1112 N Milwaukee Ave"
		],
		"city": "Chicago",
		"state": "IL",
		"zip": "60642",
		"lat": 41.901793,
		"long": -87.664462
	},
	{
		"name": "AMC Loews Crestwood 18",
		"address": [
			"13221 Rivercrest Drive"
		],
		"city": "Crestwood",
		"state": "IL",
		"zip": "60445",
		"lat": 41.65158,
		"long": -87.7439799
	},
	{
		"name": "Loews Theatres Gardens 1-6",
		"address": [
			"145 Old Orchard Shopping Ctr"
		],
		"city": "Skokie",
		"state": "IL",
		"zip": "60077",
		"lat": 42.0559463649988,
		"long": -87.7490030229092
	},
	{
		"name": "Quarry Cinemas",
		"address": [
			"9201 W. 63rd Street"
		],
		"city": "Countryside",
		"state": "IL",
		"zip": "60525",
		"lat": 41.7759649,
		"long": -87.8586357
	},
	{
		"name": "Chicago Theatre",
		"address": [
			"175 N State St"
		],
		"city": "Chicago",
		"state": "IL",
		"zip": "60601",
		"lat": 41.8854830450828,
		"long": -87.6275988288569
	},
	{
		"name": "Chicago International Children's Film Festival",
		"address": [
			"1517 W Fullerton Avenue"
		],
		"city": "Chicago",
		"state": "IL",
		"zip": "60614",
		"lat": 41.9249,
		"long": -87.66651
	},
	{
		"name": "AMC",
		"address": [
			"4620 138th St"
		],
		"city": "Crestwood",
		"state": "IL",
		"zip": "60445",
		"lat": 41.651566825345,
		"long": -87.744156268043
	},
	{
		"name": "B-Fest",
		"address": [
			"Norris University Center",
			"1999 S Campus Dr"
		],
		"city": "Evanston",
		"state": "IL",
		"zip": "60209",
		"lat": 42.054186835885,
		"long": -87.6739601790905
	},
	{
		"name": "Splitpillow",
		"address": [],
		"city": "Chicago",
		"state": "IL",
		"zip": "60689",
		"lat": 41.8744277954102,
		"long": -87.6373825073242
	},
	{
		"name": "Millenium Park Summer Film Series",
		"address": [
			"Millennium Park",
			"201 East Randolph St"
		],
		"city": "Chicago",
		"state": "IL",
		"zip": "60601",
		"lat": 41.8834,
		"long": -87.62246
	},
	{
		"name": "Silent Film Society of Chicago",
		"address": [
			"4050 N Milwaukee Ave"
		],
		"city": "Chicago",
		"state": "IL",
		"zip": "60641",
		"lat": 41.9542154,
		"long": -87.7489356
	},
	{
		"name": "Hoosier Theatre",
		"address": [
			"1335 119th St"
		],
		"city": "Whiting",
		"state": "IN",
		"zip": "46394",
		"lat": 41.6794499,
		"long": -87.4963745
	},
	{
		"name": "AMC Theatres",
		"address": [
			"322 E Illinois St"
		],
		"city": "Chicago",
		"state": "IL",
		"zip": "60610",
		"lat": 41.8914222717285,
		"long": -87.6189346313477
	},
	{
		"name": "AMC Northbrook Court 14",
		"address": [
			"1525 Lake Cook Rd"
		],
		"city": "Northbrook",
		"state": "IL",
		"zip": "60062",
		"lat": 42.1524208,
		"long": -87.815732
	},
	{
		"name": "Regal Cinemas Gardens 1-6",
		"address": [
			"4999 Old Orchard Center",
			"Ste N47"
		],
		"city": "Skokie",
		"state": "IL",
		"zip": "60077",
		"lat": 42.05939,
		"long": -87.7493224
	},
	{
		"name": "Landmark Renaissance Cinema",
		"address": [
			"1850 2nd St"
		],
		"city": "Highland Park",
		"state": "IL",
		"zip": "60035",
		"lat": 42.1862602233887,
		"long": -87.8019638061523
	},
	{
		"name": "ArcLight Cinemas Glenview",
		"address": [
			"1850 Tower Dr"
		],
		"city": "Glenview",
		"state": "IL",
		"zip": "60026",
		"lat": 42.0885479185773,
		"long": -87.8240644936096
	},
	{
		"name": "Digiplex Lansing 8",
		"address": [
			"16621 Torrence Ave"
		],
		"city": "Lansing",
		"state": "IL",
		"zip": "60438",
		"lat": 41.5939784,
		"long": -87.5584723
	},
	{
		"name": "Horrorbles",
		"address": [
			"6729 Stanley Ave"
		],
		"city": "Berwyn",
		"state": "IL",
		"zip": "60402",
		"lat": 41.8340559,
		"long": -87.792256
	},
	{
		"name": "Marcus Chicago Heights",
		"address": [
			"1301 Hilltop Ave"
		],
		"city": "Chicago Heights",
		"state": "IL",
		"zip": "60411",
		"lat": 41.5083,
		"long": -87.66851
	}
];


/*****************
 ** WEBPACK FOOTER
 ** ./src/data/theatres.json
 ** module id = 78
 ** module chunks = 0
 **/